import { Box, Flex, Spacer, Button } from "@chakra-ui/react"
import WalletSpace from './walletspace'
import {useWeb3React } from '@web3-react/core'
import logo from '../images/logo.png'

const Header = (props) => {
    const {account } = useWeb3React()
    /*
        {(account) && 
                <img src={sglogo} alt='sgt logo' width={30} style={{marginLeft: 30, marginTop: 5}} />
        }
    */
   /*
        <Box >
                <a href='https://www.bitmart.co.za/'><img src={logo} alt='logo' width={150} style={{marginLeft: 20, marginTop: 10}}/></a>
            </Box>
   */
    return (
    <Flex alignItems="right" minWidth="100%">
            
            <Spacer />
            {false && account && !props.isAdmin && 
                <Box style={{marginTop: 7, marginRight: 20}}><Button variant='link' onClick={()=>props.showYieldTokens(!props.yieldTokensShow)}>{(!props.yieldTokensShow)?'My Yield Tokens':'Main Page'}</Button></Box>
            }
            {props.isAdmin &&
                <Box style={{marginTop: 7, marginRight: 20}}><Button variant='link' onClick={()=>props.setAdminOpen()}>{(!props.adminOpen)?'Admin Page':'Main Page'}</Button></Box>
            }
            
            <WalletSpace onChange={props.onChange}/>
    </Flex>
    )
}

export default Header